import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "landing-page__addOffer-universal",
  class: "landing-page"
}
const _hoisted_2 = {
  id: "body",
  class: "fullwidth"
}
const _hoisted_3 = { class: "page-header" }
const _hoisted_4 = { class: "width-wrap" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "icon-list columns is-2 is-multiline" }
const _hoisted_9 = { class: "icon-list__item column" }
const _hoisted_10 = { class: "icon-list__item-image" }
const _hoisted_11 = { class: "icon-list__item-content" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "icon-list__item column" }
const _hoisted_14 = { class: "icon-list__item-image" }
const _hoisted_15 = { class: "icon-list__item-content" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "icon-list__item column" }
const _hoisted_18 = { class: "icon-list__item-image" }
const _hoisted_19 = { class: "icon-list__item-content" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "icon-list__item column" }
const _hoisted_22 = { class: "icon-list__item-image" }
const _hoisted_23 = { class: "icon-list__item-content" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "icon-list__item column" }
const _hoisted_26 = { class: "icon-list__item-image" }
const _hoisted_27 = { class: "icon-list__item-content" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "icon-list__item column" }
const _hoisted_30 = { class: "icon-list__item-image" }
const _hoisted_31 = { class: "icon-list__item-content" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { class: "weight-normal" }
const _hoisted_34 = { class: "squares cols-3" }
const _hoisted_35 = { class: "map" }
const _hoisted_36 = { class: "page-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_RegistrationAgent = _resolveComponent("RegistrationAgent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: { name: 'AdSearch' },
              custom: ""
            }, {
              default: _withCtx(({ href }) => [
                _createElementVNode("a", {
                  href: href,
                  id: "header-logo",
                  style: {"display":"inline-block"}
                }, [
                  _createElementVNode("img", {
                    src: _ctx.logoUrl,
                    width: "270",
                    height: "47",
                    alt: _ctx.domain + ' logo'
                  }, null, 8, _hoisted_7)
                ], 8, _hoisted_6)
              ]),
              _: 1
            }),
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t('RegistrationAgentLandingPage.header')), 1)
          ]),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('RegistrationAgentLandingPage.subheader', { domain: _ctx.domain })), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_ResizableImage, {
                  url: "/img/landing-universal/icon-01.svg",
                  alt: "icon-01"
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", {
                  innerHTML: _ctx.$t('RegistrationAgentLandingPage.properties.google-maps')
                }, null, 8, _hoisted_12)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_ResizableImage, {
                  url: "/img/landing-universal/icon-02.svg",
                  alt: "icon-02"
                })
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", {
                  innerHTML: _ctx.$t('RegistrationAgentLandingPage.properties.free')
                }, null, 8, _hoisted_16)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_ResizableImage, {
                  url: "/img/landing-universal/icon-03.svg",
                  alt: "icon-03"
                })
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("p", {
                  innerHTML: _ctx.$t('RegistrationAgentLandingPage.properties.filters')
                }, null, 8, _hoisted_20)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_ResizableImage, {
                  url: "/img/landing-universal/icon-04.svg",
                  alt: "icon-04"
                })
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("p", {
                  innerHTML: _ctx.$t('RegistrationAgentLandingPage.properties.life-cycle')
                }, null, 8, _hoisted_24)
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_ResizableImage, {
                  url: "/img/landing-universal/icon-05.svg",
                  alt: "icon-05"
                })
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("p", {
                  innerHTML: _ctx.$t('RegistrationAgentLandingPage.properties.easy-add')
                }, null, 8, _hoisted_28)
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_ResizableImage, {
                  url: "/img/landing-universal/icon-06.svg",
                  alt: "icon-06"
                })
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("p", {
                  innerHTML: _ctx.$t('RegistrationAgentLandingPage.properties.multiple-views')
                }, null, 8, _hoisted_32)
              ])
            ])
          ]),
          _createElementVNode("h2", null, [
            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('RegistrationAgentLandingPage.countries-header-1', { domain: _ctx.domain })), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('RegistrationAgentLandingPage.countries-header-2')), 1)
          ]),
          _createElementVNode("ul", _hoisted_34, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('country.cz')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('country.hu')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('country.hr')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('country.al')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('country.ae')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('country.es')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('country.pl')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('country.at')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('country.si')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('country.me')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_ResizableImage, {
            url: "/img/landing-universal/map.jpg",
            alt: "map"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createVNode(_component_RegistrationAgent)
      ])
    ])
  ]))
}